import {
  GridFieldFormattingType,
  JsonKeyValue,
  MODULE,
  Paths,
  IBaseModel,
  getNestedUnknownFieldByPath,
} from '../../common';
import { ReactElement } from 'react';
import {
  getBooleanValue,
  getCurrencyValue,
  getDateValue,
  getPercentageValue,
} from './helperFormatRules';
import { enumToKeyValueArray } from './helperEnum';
import { floatToHours } from '@jobcost-monorepo/utils';

export const gridFieldsFormatRules = <T extends IBaseModel>(
  element: T,
  linkedField: Paths<T>,
  formattingType: GridFieldFormattingType,
  translationModuleName?: MODULE,
  enumValues?: object,
): ReactElement | string => {
  const value = getNestedUnknownFieldByPath(
    element as JsonKeyValue,
    linkedField,
  );

  if (!formattingType || formattingType === 'string') return value;

  if (formattingType === 'number') {
    return value;
  }

  if (formattingType === 'currency') {
    return getCurrencyValue(value);
  }

  if (formattingType === 'percentage') {
    return getPercentageValue(value, 2);
  }

  if (formattingType === 'date') {
    return getDateValue(value);
  }

  if (formattingType === 'boolean') {
    return getBooleanValue(value);
  }

  if (formattingType === 'hours') {
    return floatToHours(value);
  }

  if (formattingType === 'enum' && enumValues && translationModuleName) {
    const list = enumToKeyValueArray(
      enumValues,
      linkedField,
      translationModuleName,
    );
    const element = list.find((el) => el.id === value);
    return element?.name ?? value;
  }

  return value;
};
